import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var SimpleTextEditor = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SimpleTextEditor, _React$Component);

  function SimpleTextEditor() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.input = /*#__PURE__*/React.createRef();
    return _this;
  }

  var _proto = SimpleTextEditor.prototype;

  _proto.getInputNode = function getInputNode() {
    return this.input.current;
  };

  _proto.getValue = function getValue() {
    var _ref;

    return _ref = {}, _ref[this.props.column.key] = this.input.current.value, _ref;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("input", {
      className: "rdg-text-editor",
      ref: this.input,
      defaultValue: this.props.value,
      onBlur: this.props.onCommit
    });
  };

  return SimpleTextEditor;
}(React.Component);

export { SimpleTextEditor as default };